module.exports = __webpack_public_path__ + "img/Veneer.63ef8ffb.svg";